class CustomStickyAtcBar extends HTMLElement {
  constructor() {
    super();
    this.stickyBarOffsetTop = 0;
    this.heightHeaderTop = 0;
    this.scrollHandler = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.scrollHandler);
  }

  connectedCallback() {
    this.initElements();
    this.calculateOffsets();
    this.syncWithMainProductForm();
    this.validateAndHideInvalidButtons();
    this.addEventScroll();
  }

  handleScroll() {
    this.calculateOffsets();
  }

  handleize(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-+/g, '-');
  }

  validateAndHideInvalidButtons() {
    const sections = document.querySelectorAll('main .shopify-section');
    const buttonToSections = this.querySelectorAll('.custom-sticky-atc-bar__button');

    buttonToSections.forEach(button => {
      const sectionTitle = button.dataset.sectionTitle

      if(sectionTitle) {
        const index = this.getSectionIndex(sectionTitle)
        const targetSection = sections[index];

        // Check if section exists and is visible
        const sectionExists = sections.length > 0 && targetSection;
        const sectionVisible = sectionExists &&
          targetSection.style.display !== 'none' &&
          targetSection.style.visibility !== 'hidden' &&
          targetSection.offsetParent !== null; // This checks if element is not hidden by CSS

        if (!sectionExists || !sectionVisible) {
          button.style.display = 'none';
        }
      }
    });
  }

  addEventScroll() {
    let self = this;
    let buttonToSections = this.querySelectorAll('.custom-sticky-atc-bar__button');
    buttonToSections.forEach(button => {
      button.addEventListener('click', () => {
        const sectionTitle = button.dataset.sectionTitle

        if(button, sectionTitle) {
          const index = this.getSectionIndex(sectionTitle)
          self.scrollToSection(index + 1);
        }
      });
    });
  }

  getSectionIndex(sectionTitle) {
    const handle_sectionTitle = this.handleize(sectionTitle)
    const sections = document.querySelectorAll('main .shopify-section')
    let index = null

    // Find Section
    document.querySelectorAll('[data-title-header], [data-oke-widget], .boost-widget__heading').forEach((el) => {
        const currentShopifySection = el.closest('.shopify-section');
        if (currentShopifySection) {
            let textContent = el.dataset.titleHeader ?? el.textContent ?? ''
            const handle = this.handleize(textContent)

            if (el.hasAttribute('data-oke-widget') && (handle_sectionTitle === 'reviews' || handle_sectionTitle === 'review')) {
              index = Array.prototype.indexOf.call(sections, currentShopifySection)
            } // reviews
            else if (el.classList.contains('boost-widget__heading')) {
                if (handle_sectionTitle === handle) {
                  index = Array.prototype.indexOf.call(sections, currentShopifySection)
                }
            } // boost-widet
            else if (textContent) {
                if (handle_sectionTitle === handle) {
                  index = Array.prototype.indexOf.call(sections, currentShopifySection)
                }
            }
        }
    })
    return index;
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.stickyOnScroll);
  }

  initElements() {
    this.mainProductInfo = document.querySelector('product-info');
    this.sectionStickyBar = document.querySelector('.shopify-section:has(.custom-sticky-atc-bar__wrapper)');
    this.stickyBarWrapper = this.querySelector('.custom-sticky-atc-bar__wrapper');
    this.headerWrapper = document.querySelector('.header__wrapper');
    this.addButton = this.querySelector('.custom-sticky-atc-bar__button.atc');
    this.atcButtonForm = document.querySelector('product-info .product-form__submit');
    if (this.addButton) {
      this.addButton.addEventListener('click', () => {
        if (this.atcButtonForm) {
          this.atcButtonForm.click();
        }
      });
    }
  }

  calculateOffsets() {
      this.heightHeaderTop = this.headerWrapper.getBoundingClientRect().height;
      this.sectionStickyBar.style.top = this.heightHeaderTop + 'px';
  }


  updateButton(disable = true, element = null , modifyClass = true) {
    if (!this.addButton) return;
    if (disable) {
      this.addButton.setAttribute('disabled', 'disabled');
    } else {
      this.addButton.removeAttribute('disabled');
    }
    if(element) this.addButton.innerHTML = element.innerHTML;

    this.addButton.classList.toggle(
      'btn--clearance--out-stock',
      element.classList.contains('btn--clearance--out-stock')
    );
  }

  syncWithMainProductForm() {
    if (!window.FoxTheme || !FoxTheme.pubsub) return;

    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
      const isMainProduct = event.data.sectionId === this.mainProductInfo?.dataset.section;
      if (!isMainProduct) return;
      const addButton = this.mainProductInfo.querySelector('.product-form__submit');
      this.updateButton(addButton.hasAttribute('disabled'), addButton, true);
    });
  }

  scrollToSection(sectionNumber) {
    let sections = document.querySelectorAll(`main .shopify-section`);
    if (sections.length > 0 && sections[sectionNumber - 1]) {
      window.scrollTo({
        top: sections[sectionNumber - 1].offsetTop,
        behavior: 'smooth'
      });
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

}

customElements.define('custom-sticky-atc-bar', CustomStickyAtcBar);
